module.exports = __webpack_public_path__ + "1ed72cb00dc79e545eb2f86b41a14560.woff";